"use strict";
/* eslint-disable */
// tslint:disable
/**
 * Umbrella API
 * The API for the Umbrella webapp, including administration and user features.
 *
 * OpenAPI spec version: 1.0.0
 * Contact: anton@cactuslab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyApi = exports.SurveyApiFactory = exports.SurveyApiFp = exports.SurveyApiFetchParamCreator = exports.PersonApi = exports.PersonApiFactory = exports.PersonApiFp = exports.PersonApiFetchParamCreator = exports.ParticipationApi = exports.ParticipationApiFactory = exports.ParticipationApiFp = exports.ParticipationApiFetchParamCreator = exports.KnowledgeLibraryApi = exports.KnowledgeLibraryApiFactory = exports.KnowledgeLibraryApiFp = exports.KnowledgeLibraryApiFetchParamCreator = exports.AuthApi = exports.AuthApiFactory = exports.AuthApiFp = exports.AuthApiFetchParamCreator = exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiFetchParamCreator = exports.AccountApi = exports.AccountApiFactory = exports.AccountApiFp = exports.AccountApiFetchParamCreator = void 0;
var runtime_1 = require("./runtime");
/**
 * AccountApi - fetch parameter creator
 * @export
 */
var AccountApiFetchParamCreator = function (configuration) {
    return {
        /**
         * <p>Participants must be added to one or more participant groups.</p>
         * @summary Add participants to the account.
         * @param {string} accountId
         * @param {Api.AddAccountParticipantsRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAccountParticipants: function (accountId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling addAccountParticipants.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling addAccountParticipants.');
            }
            var localVarPath = "/account/{accountId}/participants"
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Add existing participants to a participant group.
         * @param {string} groupId
         * @param {string} accountId
         * @param {Api.AddParticipantsToGroupRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        addParticipantsToGroup: function (groupId, accountId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new runtime_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling addParticipantsToGroup.');
            }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling addParticipantsToGroup.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling addParticipantsToGroup.');
            }
            var localVarPath = "/account/{accountId}/group/{groupId}/participants"
                .replace('{groupId}', encodeURIComponent(String(groupId)))
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} accountId
         * @param {Api.AddUsersRequest} [request]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsers: function (accountId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling addUsers.');
            }
            var localVarPath = "/account/{accountId}/users"
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Create a new participant group.
         * @param {string} accountId
         * @param {Api.CreateGroupRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup: function (accountId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createGroup.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling createGroup.');
            }
            var localVarPath = "/account/{accountId}/group"
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Create a new survey for an account
         * @param {string} accountId
         * @param {Api.CreateSurveyRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey: function (accountId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createSurvey.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling createSurvey.');
            }
            var localVarPath = "/account/{accountId}/surveys"
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * <p>Deletes participants from an entire account; removing them from all groups and surveys.</p>
         * @summary Delete participants from the account.
         * @param {string} accountId
         * @param {Api.DeleteAccountParticipantsRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountParticipants: function (accountId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteAccountParticipants.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling deleteAccountParticipants.');
            }
            var localVarPath = "/account/{accountId}/participants"
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Delete a participant group.
         * @param {string} groupId
         * @param {string} accountId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup: function (groupId, accountId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new runtime_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteGroup.');
            }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteGroup.');
            }
            var localVarPath = "/account/{accountId}/group/{groupId}"
                .replace('{groupId}', encodeURIComponent(String(groupId)))
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Deletes all the participant's answer for survey specified.
         * @param {string} accountId
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurveyResults: function (accountId, surveyId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteSurveyResults.');
            }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling deleteSurveyResults.');
            }
            var localVarPath = "/account/{accountId}/survey/{surveyId}"
                .replace('{accountId}', encodeURIComponent(String(accountId)))
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Download anonymised report as a XLS
         * @param {string} accountId
         * @param {string} surveyId
         * @param {string} token <p>The download token</p>
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAnonymisedSurveyReport: function (accountId, surveyId, token, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling downloadAnonymisedSurveyReport.');
            }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling downloadAnonymisedSurveyReport.');
            }
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new runtime_1.RequiredError('token', 'Required parameter token was null or undefined when calling downloadAnonymisedSurveyReport.');
            }
            var localVarPath = "/account/{accountId}/survey/{surveyId}/report/download"
                .replace('{accountId}', encodeURIComponent(String(accountId)))
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            if (token !== undefined) {
                localVarQueryParameter.append('token', String(token));
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Get the details of the given account
         * @param {string} accountId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: function (accountId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getAccount.');
            }
            var localVarPath = "/account/{accountId}"
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * <p>The participants for an account include all of the participants that have been used in surveys
         * or appear in participant groups for this account.</p>
         * @summary Get a list of participants for the account.
         * @param {string} accountId
         * @param {string} [cursor]
         * @param {Api.SortParticipants} [sort]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountParticipants: function (accountId, cursor, sort, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getAccountParticipants.');
            }
            var localVarPath = "/account/{accountId}/participants"
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            if (cursor !== undefined) {
                localVarQueryParameter.append('cursor', String(cursor));
            }
            if (sort !== undefined) {
                localVarQueryParameter.append('sort', String(sort));
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} groupId
         * @param {string} accountId
         * @param {string} [cursor]
         * @param {Api.SortParticipants} [sort]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupParticipants: function (groupId, accountId, cursor, sort, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new runtime_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getGroupParticipants.');
            }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getGroupParticipants.');
            }
            var localVarPath = "/account/{accountId}/group/{groupId}/participants"
                .replace('{groupId}', encodeURIComponent(String(groupId)))
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            if (cursor !== undefined) {
                localVarQueryParameter.append('cursor', String(cursor));
            }
            if (sort !== undefined) {
                localVarQueryParameter.append('sort', String(sort));
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Get a list of the participant groups for this account.
         * @param {string} accountId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: function (accountId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getGroups.');
            }
            var localVarPath = "/account/{accountId}/groups"
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Get a list of surveys for the Account
         * @param {string} accountId
         * @param {string} [cursor]
         * @param {Api.SortSurveys} [sort]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReports: function (accountId, cursor, sort, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getReports.');
            }
            var localVarPath = "/account/{accountId}/reports"
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            if (cursor !== undefined) {
                localVarQueryParameter.append('cursor', String(cursor));
            }
            if (sort !== undefined) {
                localVarQueryParameter.append('sort', String(sort));
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Get a list of active surveys for the Account
         * @param {string} accountId
         * @param {string} [cursor]
         * @param {Api.SortSurveys} [sort]
         * @param {Api.FilterSurveys[]} [filter] <p>The default filter is <code>current</code>.</p>
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveys: function (accountId, cursor, sort, filter, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getSurveys.');
            }
            var localVarPath = "/account/{accountId}/surveys"
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            if (cursor !== undefined) {
                localVarQueryParameter.append('cursor', String(cursor));
            }
            if (sort !== undefined) {
                localVarQueryParameter.append('sort', String(sort));
            }
            if (filter !== undefined) {
                /* array form exploded */
                for (var _i = 0, filter_1 = filter; _i < filter_1.length; _i++) {
                    var localVarArrayElement = filter_1[_i];
                    if (localVarArrayElement !== undefined) {
                        localVarQueryParameter.append('filter', localVarArrayElement !== null ? String(localVarArrayElement) : '');
                    }
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Get the available survey templates for the account
         * @param {string} accountId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyTemplates: function (accountId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getSurveyTemplates.');
            }
            var localVarPath = "/account/{accountId}/surveys/templates"
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} accountId
         * @param {string} [cursor]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (accountId, cursor, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getUsers.');
            }
            var localVarPath = "/account/{accountId}/users"
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            if (cursor !== undefined) {
                localVarQueryParameter.append('cursor', String(cursor));
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Update account details
         * @param {string} accountId
         * @param {Api.PatchAccountRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAccount: function (accountId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling patchAccount.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling patchAccount.');
            }
            var localVarPath = "/account/{accountId}"
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * <p>when account admin updates person given/family name instead of updating it against person, we update their membership given/family name
         * #TODO may need to have separate endpoint for person to update their personal data</p>
         * @summary patch participants membership to the account.
         * @param {string} accountId
         * @param {string} participantId
         * @param {Api.PatchAccountParticipantRequest} request <p>The details with which to update account membership of participant specified</p>
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAccountParticipant: function (accountId, participantId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling patchAccountParticipant.');
            }
            // verify required parameter 'participantId' is not null or undefined
            if (participantId === null || participantId === undefined) {
                throw new runtime_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling patchAccountParticipant.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling patchAccountParticipant.');
            }
            var localVarPath = "/account/{accountId}/participant/{participantId}"
                .replace('{accountId}', encodeURIComponent(String(accountId)))
                .replace('{participantId}', encodeURIComponent(String(participantId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Update some of the participant group details.
         * @param {string} groupId
         * @param {string} accountId
         * @param {Api.PatchGroupRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchGroup: function (groupId, accountId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new runtime_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling patchGroup.');
            }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling patchGroup.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling patchGroup.');
            }
            var localVarPath = "/account/{accountId}/group/{groupId}"
                .replace('{groupId}', encodeURIComponent(String(groupId)))
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} groupId
         * @param {string} accountId
         * @param {Api.RemoveGroupParticipantsRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGroupParticipants: function (groupId, accountId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new runtime_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling removeGroupParticipants.');
            }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling removeGroupParticipants.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling removeGroupParticipants.');
            }
            var localVarPath = "/account/{accountId}/group/{groupId}/participants"
                .replace('{groupId}', encodeURIComponent(String(groupId)))
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} accountId
         * @param {string} userId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUser: function (accountId, userId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling removeUser.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new runtime_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling removeUser.');
            }
            var localVarPath = "/account/{accountId}/users/{userId}"
                .replace('{accountId}', encodeURIComponent(String(accountId)))
                .replace('{userId}', encodeURIComponent(String(userId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Request a token to download a report
         * @param {string} accountId
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAnonymisedSurveyReportDownload: function (accountId, surveyId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling requestAnonymisedSurveyReportDownload.');
            }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling requestAnonymisedSurveyReportDownload.');
            }
            var localVarPath = "/account/{accountId}/survey/{surveyId}/report/request-download"
                .replace('{accountId}', encodeURIComponent(String(accountId)))
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} accountId
         * @param {string} query
         * @param {string} [cursor]
         * @param {Api.SortParticipants} [sort]
         * @param {string} [group]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchParticipants: function (accountId, query, cursor, sort, group, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling searchParticipants.');
            }
            // verify required parameter 'query' is not null or undefined
            if (query === null || query === undefined) {
                throw new runtime_1.RequiredError('query', 'Required parameter query was null or undefined when calling searchParticipants.');
            }
            var localVarPath = "/account/{accountId}/participants/search"
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            if (query !== undefined) {
                localVarQueryParameter.append('query', String(query));
            }
            if (cursor !== undefined) {
                localVarQueryParameter.append('cursor', String(cursor));
            }
            if (sort !== undefined) {
                localVarQueryParameter.append('sort', String(sort));
            }
            if (group !== undefined) {
                localVarQueryParameter.append('group', String(group));
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} accountId
         * @param {string} userId
         * @param {Api.UpdateUserRequest} [request]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (accountId, userId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new runtime_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateUser.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new runtime_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling updateUser.');
            }
            var localVarPath = "/account/{accountId}/users/{userId}"
                .replace('{accountId}', encodeURIComponent(String(accountId)))
                .replace('{userId}', encodeURIComponent(String(userId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AccountApiFetchParamCreator = AccountApiFetchParamCreator;
/**
 * AccountApi - functional programming interface
 * @export
 */
var AccountApiFp = function (configuration) {
    return {
        /**
         * <p>Participants must be added to one or more participant groups.</p>
         * @summary Add participants to the account.
         * @param {string} accountId
         * @param {Api.AddAccountParticipantsRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAccountParticipants: function (accountId, request, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).addAccountParticipants(accountId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Add existing participants to a participant group.
         * @param {string} groupId
         * @param {string} accountId
         * @param {Api.AddParticipantsToGroupRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        addParticipantsToGroup: function (groupId, accountId, request, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).addParticipantsToGroup(groupId, accountId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 201) {
                        return response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} accountId
         * @param {Api.AddUsersRequest} [request]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsers: function (accountId, request, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).addUsers(accountId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 204) {
                        return response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Create a new participant group.
         * @param {string} accountId
         * @param {Api.CreateGroupRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup: function (accountId, request, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).createGroup(accountId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 201) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Create a new survey for an account
         * @param {string} accountId
         * @param {Api.CreateSurveyRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey: function (accountId, request, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).createSurvey(accountId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * <p>Deletes participants from an entire account; removing them from all groups and surveys.</p>
         * @summary Delete participants from the account.
         * @param {string} accountId
         * @param {Api.DeleteAccountParticipantsRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountParticipants: function (accountId, request, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).deleteAccountParticipants(accountId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 204) {
                        return response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Delete a participant group.
         * @param {string} groupId
         * @param {string} accountId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup: function (groupId, accountId, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).deleteGroup(groupId, accountId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 204) {
                        return response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Deletes all the participant's answer for survey specified.
         * @param {string} accountId
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurveyResults: function (accountId, surveyId, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).deleteSurveyResults(accountId, surveyId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 204) {
                        return response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Download anonymised report as a XLS
         * @param {string} accountId
         * @param {string} surveyId
         * @param {string} token <p>The download token</p>
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAnonymisedSurveyReport: function (accountId, surveyId, token, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).downloadAnonymisedSurveyReport(accountId, surveyId, token, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        return response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Get the details of the given account
         * @param {string} accountId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: function (accountId, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).getAccount(accountId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * <p>The participants for an account include all of the participants that have been used in surveys
         * or appear in participant groups for this account.</p>
         * @summary Get a list of participants for the account.
         * @param {string} accountId
         * @param {string} [cursor]
         * @param {Api.SortParticipants} [sort]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountParticipants: function (accountId, cursor, sort, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).getAccountParticipants(accountId, cursor, sort, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} groupId
         * @param {string} accountId
         * @param {string} [cursor]
         * @param {Api.SortParticipants} [sort]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupParticipants: function (groupId, accountId, cursor, sort, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).getGroupParticipants(groupId, accountId, cursor, sort, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Get a list of the participant groups for this account.
         * @param {string} accountId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: function (accountId, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).getGroups(accountId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Get a list of surveys for the Account
         * @param {string} accountId
         * @param {string} [cursor]
         * @param {Api.SortSurveys} [sort]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReports: function (accountId, cursor, sort, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).getReports(accountId, cursor, sort, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Get a list of active surveys for the Account
         * @param {string} accountId
         * @param {string} [cursor]
         * @param {Api.SortSurveys} [sort]
         * @param {Api.FilterSurveys[]} [filter] <p>The default filter is <code>current</code>.</p>
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveys: function (accountId, cursor, sort, filter, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).getSurveys(accountId, cursor, sort, filter, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Get the available survey templates for the account
         * @param {string} accountId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyTemplates: function (accountId, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).getSurveyTemplates(accountId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} accountId
         * @param {string} [cursor]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (accountId, cursor, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).getUsers(accountId, cursor, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Update account details
         * @param {string} accountId
         * @param {Api.PatchAccountRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAccount: function (accountId, request, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).patchAccount(accountId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * <p>when account admin updates person given/family name instead of updating it against person, we update their membership given/family name
         * #TODO may need to have separate endpoint for person to update their personal data</p>
         * @summary patch participants membership to the account.
         * @param {string} accountId
         * @param {string} participantId
         * @param {Api.PatchAccountParticipantRequest} request <p>The details with which to update account membership of participant specified</p>
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAccountParticipant: function (accountId, participantId, request, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).patchAccountParticipant(accountId, participantId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Update some of the participant group details.
         * @param {string} groupId
         * @param {string} accountId
         * @param {Api.PatchGroupRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchGroup: function (groupId, accountId, request, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).patchGroup(groupId, accountId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} groupId
         * @param {string} accountId
         * @param {Api.RemoveGroupParticipantsRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGroupParticipants: function (groupId, accountId, request, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).removeGroupParticipants(groupId, accountId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 204) {
                        return response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} accountId
         * @param {string} userId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUser: function (accountId, userId, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).removeUser(accountId, userId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 204) {
                        return response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Request a token to download a report
         * @param {string} accountId
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAnonymisedSurveyReportDownload: function (accountId, surveyId, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).requestAnonymisedSurveyReportDownload(accountId, surveyId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} accountId
         * @param {string} query
         * @param {string} [cursor]
         * @param {Api.SortParticipants} [sort]
         * @param {string} [group]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchParticipants: function (accountId, query, cursor, sort, group, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).searchParticipants(accountId, query, cursor, sort, group, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} accountId
         * @param {string} userId
         * @param {Api.UpdateUserRequest} [request]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (accountId, userId, request, options) {
            var localVarFetchArgs = (0, exports.AccountApiFetchParamCreator)(configuration).updateUser(accountId, userId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
    };
};
exports.AccountApiFp = AccountApiFp;
/**
 * AccountApi - factory interface
 * @export
 */
var AccountApiFactory = function (configuration, basePath, fetch) {
    return new AccountApi(configuration, basePath, fetch);
};
exports.AccountApiFactory = AccountApiFactory;
/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
var AccountApi = /** @class */ (function (_super) {
    __extends(AccountApi, _super);
    function AccountApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * <p>Participants must be added to one or more participant groups.</p>
     * @summary Add participants to the account.
     * @param {string} accountId
     * @param {Api.AddAccountParticipantsRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.addAccountParticipants = function (accountId, request, options) {
        return (0, exports.AccountApiFp)(this.configuration).addAccountParticipants(accountId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Add existing participants to a participant group.
     * @param {string} groupId
     * @param {string} accountId
     * @param {Api.AddParticipantsToGroupRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.addParticipantsToGroup = function (groupId, accountId, request, options) {
        return (0, exports.AccountApiFp)(this.configuration).addParticipantsToGroup(groupId, accountId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} accountId
     * @param {Api.AddUsersRequest} [request]
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.addUsers = function (accountId, request, options) {
        return (0, exports.AccountApiFp)(this.configuration).addUsers(accountId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Create a new participant group.
     * @param {string} accountId
     * @param {Api.CreateGroupRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.createGroup = function (accountId, request, options) {
        return (0, exports.AccountApiFp)(this.configuration).createGroup(accountId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Create a new survey for an account
     * @param {string} accountId
     * @param {Api.CreateSurveyRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.createSurvey = function (accountId, request, options) {
        return (0, exports.AccountApiFp)(this.configuration).createSurvey(accountId, request, options)(this.fetch, this.basePath);
    };
    /**
     * <p>Deletes participants from an entire account; removing them from all groups and surveys.</p>
     * @summary Delete participants from the account.
     * @param {string} accountId
     * @param {Api.DeleteAccountParticipantsRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.deleteAccountParticipants = function (accountId, request, options) {
        return (0, exports.AccountApiFp)(this.configuration).deleteAccountParticipants(accountId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Delete a participant group.
     * @param {string} groupId
     * @param {string} accountId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.deleteGroup = function (groupId, accountId, options) {
        return (0, exports.AccountApiFp)(this.configuration).deleteGroup(groupId, accountId, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Deletes all the participant's answer for survey specified.
     * @param {string} accountId
     * @param {string} surveyId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.deleteSurveyResults = function (accountId, surveyId, options) {
        return (0, exports.AccountApiFp)(this.configuration).deleteSurveyResults(accountId, surveyId, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Download anonymised report as a XLS
     * @param {string} accountId
     * @param {string} surveyId
     * @param {string} token <p>The download token</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.downloadAnonymisedSurveyReport = function (accountId, surveyId, token, options) {
        return (0, exports.AccountApiFp)(this.configuration).downloadAnonymisedSurveyReport(accountId, surveyId, token, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Get the details of the given account
     * @param {string} accountId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.getAccount = function (accountId, options) {
        return (0, exports.AccountApiFp)(this.configuration).getAccount(accountId, options)(this.fetch, this.basePath);
    };
    /**
     * <p>The participants for an account include all of the participants that have been used in surveys
     * or appear in participant groups for this account.</p>
     * @summary Get a list of participants for the account.
     * @param {string} accountId
     * @param {string} [cursor]
     * @param {Api.SortParticipants} [sort]
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.getAccountParticipants = function (accountId, cursor, sort, options) {
        return (0, exports.AccountApiFp)(this.configuration).getAccountParticipants(accountId, cursor, sort, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} groupId
     * @param {string} accountId
     * @param {string} [cursor]
     * @param {Api.SortParticipants} [sort]
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.getGroupParticipants = function (groupId, accountId, cursor, sort, options) {
        return (0, exports.AccountApiFp)(this.configuration).getGroupParticipants(groupId, accountId, cursor, sort, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Get a list of the participant groups for this account.
     * @param {string} accountId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.getGroups = function (accountId, options) {
        return (0, exports.AccountApiFp)(this.configuration).getGroups(accountId, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Get a list of surveys for the Account
     * @param {string} accountId
     * @param {string} [cursor]
     * @param {Api.SortSurveys} [sort]
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.getReports = function (accountId, cursor, sort, options) {
        return (0, exports.AccountApiFp)(this.configuration).getReports(accountId, cursor, sort, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Get a list of active surveys for the Account
     * @param {string} accountId
     * @param {string} [cursor]
     * @param {Api.SortSurveys} [sort]
     * @param {Api.FilterSurveys[]} [filter] <p>The default filter is <code>current</code>.</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.getSurveys = function (accountId, cursor, sort, filter, options) {
        return (0, exports.AccountApiFp)(this.configuration).getSurveys(accountId, cursor, sort, filter, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Get the available survey templates for the account
     * @param {string} accountId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.getSurveyTemplates = function (accountId, options) {
        return (0, exports.AccountApiFp)(this.configuration).getSurveyTemplates(accountId, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} accountId
     * @param {string} [cursor]
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.getUsers = function (accountId, cursor, options) {
        return (0, exports.AccountApiFp)(this.configuration).getUsers(accountId, cursor, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Update account details
     * @param {string} accountId
     * @param {Api.PatchAccountRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.patchAccount = function (accountId, request, options) {
        return (0, exports.AccountApiFp)(this.configuration).patchAccount(accountId, request, options)(this.fetch, this.basePath);
    };
    /**
     * <p>when account admin updates person given/family name instead of updating it against person, we update their membership given/family name
     * #TODO may need to have separate endpoint for person to update their personal data</p>
     * @summary patch participants membership to the account.
     * @param {string} accountId
     * @param {string} participantId
     * @param {Api.PatchAccountParticipantRequest} request <p>The details with which to update account membership of participant specified</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.patchAccountParticipant = function (accountId, participantId, request, options) {
        return (0, exports.AccountApiFp)(this.configuration).patchAccountParticipant(accountId, participantId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Update some of the participant group details.
     * @param {string} groupId
     * @param {string} accountId
     * @param {Api.PatchGroupRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.patchGroup = function (groupId, accountId, request, options) {
        return (0, exports.AccountApiFp)(this.configuration).patchGroup(groupId, accountId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} groupId
     * @param {string} accountId
     * @param {Api.RemoveGroupParticipantsRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.removeGroupParticipants = function (groupId, accountId, request, options) {
        return (0, exports.AccountApiFp)(this.configuration).removeGroupParticipants(groupId, accountId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} accountId
     * @param {string} userId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.removeUser = function (accountId, userId, options) {
        return (0, exports.AccountApiFp)(this.configuration).removeUser(accountId, userId, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Request a token to download a report
     * @param {string} accountId
     * @param {string} surveyId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.requestAnonymisedSurveyReportDownload = function (accountId, surveyId, options) {
        return (0, exports.AccountApiFp)(this.configuration).requestAnonymisedSurveyReportDownload(accountId, surveyId, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} accountId
     * @param {string} query
     * @param {string} [cursor]
     * @param {Api.SortParticipants} [sort]
     * @param {string} [group]
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.searchParticipants = function (accountId, query, cursor, sort, group, options) {
        return (0, exports.AccountApiFp)(this.configuration).searchParticipants(accountId, query, cursor, sort, group, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} accountId
     * @param {string} userId
     * @param {Api.UpdateUserRequest} [request]
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AccountApi.prototype.updateUser = function (accountId, userId, request, options) {
        return (0, exports.AccountApiFp)(this.configuration).updateUser(accountId, userId, request, options)(this.fetch, this.basePath);
    };
    return AccountApi;
}(runtime_1.BaseAPI));
exports.AccountApi = AccountApi;
/**
 * AdminApi - fetch parameter creator
 * @export
 */
var AdminApiFetchParamCreator = function (configuration) {
    return {
        /**
         * @summary Create an account.
         * @param {Api.CreateAccountRequest} [request]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: function (request, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/admin/accounts";
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Get all accounts.
         * @param {boolean} [archived]
         * @param {string} [cursor]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts: function (archived, cursor, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/admin/accounts";
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            if (archived !== undefined) {
                localVarQueryParameter.append('archived', String(archived));
            }
            if (cursor !== undefined) {
                localVarQueryParameter.append('cursor', String(cursor));
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} query
         * @param {boolean} [archived]
         * @param {string} [cursor]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAccounts: function (query, archived, cursor, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'query' is not null or undefined
            if (query === null || query === undefined) {
                throw new runtime_1.RequiredError('query', 'Required parameter query was null or undefined when calling searchAccounts.');
            }
            var localVarPath = "/admin/accounts/search";
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            if (query !== undefined) {
                localVarQueryParameter.append('query', String(query));
            }
            if (archived !== undefined) {
                localVarQueryParameter.append('archived', String(archived));
            }
            if (cursor !== undefined) {
                localVarQueryParameter.append('cursor', String(cursor));
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AdminApiFetchParamCreator = AdminApiFetchParamCreator;
/**
 * AdminApi - functional programming interface
 * @export
 */
var AdminApiFp = function (configuration) {
    return {
        /**
         * @summary Create an account.
         * @param {Api.CreateAccountRequest} [request]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: function (request, options) {
            var localVarFetchArgs = (0, exports.AdminApiFetchParamCreator)(configuration).createAccount(request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Get all accounts.
         * @param {boolean} [archived]
         * @param {string} [cursor]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts: function (archived, cursor, options) {
            var localVarFetchArgs = (0, exports.AdminApiFetchParamCreator)(configuration).getAccounts(archived, cursor, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} query
         * @param {boolean} [archived]
         * @param {string} [cursor]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAccounts: function (query, archived, cursor, options) {
            var localVarFetchArgs = (0, exports.AdminApiFetchParamCreator)(configuration).searchAccounts(query, archived, cursor, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
    };
};
exports.AdminApiFp = AdminApiFp;
/**
 * AdminApi - factory interface
 * @export
 */
var AdminApiFactory = function (configuration, basePath, fetch) {
    return new AdminApi(configuration, basePath, fetch);
};
exports.AdminApiFactory = AdminApiFactory;
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
var AdminApi = /** @class */ (function (_super) {
    __extends(AdminApi, _super);
    function AdminApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @summary Create an account.
     * @param {Api.CreateAccountRequest} [request]
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminApi.prototype.createAccount = function (request, options) {
        return (0, exports.AdminApiFp)(this.configuration).createAccount(request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Get all accounts.
     * @param {boolean} [archived]
     * @param {string} [cursor]
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminApi.prototype.getAccounts = function (archived, cursor, options) {
        return (0, exports.AdminApiFp)(this.configuration).getAccounts(archived, cursor, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} query
     * @param {boolean} [archived]
     * @param {string} [cursor]
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AdminApi.prototype.searchAccounts = function (query, archived, cursor, options) {
        return (0, exports.AdminApiFp)(this.configuration).searchAccounts(query, archived, cursor, options)(this.fetch, this.basePath);
    };
    return AdminApi;
}(runtime_1.BaseAPI));
exports.AdminApi = AdminApi;
/**
 * AuthApi - fetch parameter creator
 * @export
 */
var AuthApiFetchParamCreator = function (configuration) {
    return {
        /**
         * @summary Reset the password for a user.
         * @param {Api.PostRequestResetPasswordRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRequestResetPassword: function (request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling postRequestResetPassword.');
            }
            var localVarPath = "/auth/request-reset-password";
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Reset the password for a user.
         * @param {Api.PostResetPasswordRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResetPassword: function (request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling postResetPassword.');
            }
            var localVarPath = "/auth/reset-password";
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * <p>Use this endpoint to generate or refresh an auth token. See <a href='#auth'>Authentication</a> for more details.</p>
         * @summary Obtain an access token for a `Person` or `Participation`
         * @param {Api.SignInRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        signIn: function (request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling signIn.');
            }
            var localVarPath = "/auth/token";
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            localVarHeaderParameter.set('Content-Type', 'application/x-www-form-urlencoded');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                var localVarFormParams = new URLSearchParams();
                if (request["grant_type"] !== undefined) {
                    localVarFormParams.append('grant_type', String(request["grant_type"]));
                }
                if (request["client_id"] !== undefined) {
                    localVarFormParams.append('client_id', String(request["client_id"]));
                }
                if (request["client_secret"] !== undefined) {
                    localVarFormParams.append('client_secret', String(request["client_secret"]));
                }
                if (request["username"] !== undefined) {
                    localVarFormParams.append('username', String(request["username"]));
                }
                if (request["password"] !== undefined) {
                    localVarFormParams.append('password', String(request["password"]));
                }
                if (request["totp"] !== undefined) {
                    localVarFormParams.append('totp', String(request["totp"]));
                }
                if (request["refresh_token"] !== undefined) {
                    localVarFormParams.append('refresh_token', String(request["refresh_token"]));
                }
                localVarRequestOptions.body = localVarFormParams;
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Revokes tokens for signing out. Usually you supply the `refresh_token`, which will result in both the `refresh_token` and its
        associated `access_token` being revoked.
        
         * @param {Api.SignOutRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOut: function (request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling signOut.');
            }
            var localVarPath = "/auth/revoke";
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            localVarHeaderParameter.set('Content-Type', 'application/x-www-form-urlencoded');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                var localVarFormParams = new URLSearchParams();
                if (request["token_type_hint"] !== undefined) {
                    localVarFormParams.append('token_type_hint', String(request["token_type_hint"]));
                }
                if (request["token"] !== undefined) {
                    localVarFormParams.append('token', String(request["token"]));
                }
                if (request["client_id"] !== undefined) {
                    localVarFormParams.append('client_id', String(request["client_id"]));
                }
                if (request["client_secret"] !== undefined) {
                    localVarFormParams.append('client_secret', String(request["client_secret"]));
                }
                localVarRequestOptions.body = localVarFormParams;
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AuthApiFetchParamCreator = AuthApiFetchParamCreator;
/**
 * AuthApi - functional programming interface
 * @export
 */
var AuthApiFp = function (configuration) {
    return {
        /**
         * @summary Reset the password for a user.
         * @param {Api.PostRequestResetPasswordRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRequestResetPassword: function (request, options) {
            var localVarFetchArgs = (0, exports.AuthApiFetchParamCreator)(configuration).postRequestResetPassword(request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 204) {
                        return response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Reset the password for a user.
         * @param {Api.PostResetPasswordRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResetPassword: function (request, options) {
            var localVarFetchArgs = (0, exports.AuthApiFetchParamCreator)(configuration).postResetPassword(request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 204) {
                        return response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * <p>Use this endpoint to generate or refresh an auth token. See <a href='#auth'>Authentication</a> for more details.</p>
         * @summary Obtain an access token for a `Person` or `Participation`
         * @param {Api.SignInRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        signIn: function (request, options) {
            var localVarFetchArgs = (0, exports.AuthApiFetchParamCreator)(configuration).signIn(request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Revokes tokens for signing out. Usually you supply the `refresh_token`, which will result in both the `refresh_token` and its
        associated `access_token` being revoked.
        
         * @param {Api.SignOutRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOut: function (request, options) {
            var localVarFetchArgs = (0, exports.AuthApiFetchParamCreator)(configuration).signOut(request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        return response;
                    }
                    throw response;
                });
            };
        },
    };
};
exports.AuthApiFp = AuthApiFp;
/**
 * AuthApi - factory interface
 * @export
 */
var AuthApiFactory = function (configuration, basePath, fetch) {
    return new AuthApi(configuration, basePath, fetch);
};
exports.AuthApiFactory = AuthApiFactory;
/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
var AuthApi = /** @class */ (function (_super) {
    __extends(AuthApi, _super);
    function AuthApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @summary Reset the password for a user.
     * @param {Api.PostRequestResetPasswordRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AuthApi.prototype.postRequestResetPassword = function (request, options) {
        return (0, exports.AuthApiFp)(this.configuration).postRequestResetPassword(request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Reset the password for a user.
     * @param {Api.PostResetPasswordRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AuthApi.prototype.postResetPassword = function (request, options) {
        return (0, exports.AuthApiFp)(this.configuration).postResetPassword(request, options)(this.fetch, this.basePath);
    };
    /**
     * <p>Use this endpoint to generate or refresh an auth token. See <a href='#auth'>Authentication</a> for more details.</p>
     * @summary Obtain an access token for a `Person` or `Participation`
     * @param {Api.SignInRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AuthApi.prototype.signIn = function (request, options) {
        return (0, exports.AuthApiFp)(this.configuration).signIn(request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Revokes tokens for signing out. Usually you supply the `refresh_token`, which will result in both the `refresh_token` and its
    associated `access_token` being revoked.
    
     * @param {Api.SignOutRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    AuthApi.prototype.signOut = function (request, options) {
        return (0, exports.AuthApiFp)(this.configuration).signOut(request, options)(this.fetch, this.basePath);
    };
    return AuthApi;
}(runtime_1.BaseAPI));
exports.AuthApi = AuthApi;
/**
 * KnowledgeLibraryApi - fetch parameter creator
 * @export
 */
var KnowledgeLibraryApiFetchParamCreator = function (configuration) {
    return {
        /**
         * @param {string} uri
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        findKnowledgeLibraryObject: function (uri, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'uri' is not null or undefined
            if (uri === null || uri === undefined) {
                throw new runtime_1.RequiredError('uri', 'Required parameter uri was null or undefined when calling findKnowledgeLibraryObject.');
            }
            var localVarPath = "/knowledge-library/find";
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            if (uri !== undefined) {
                localVarQueryParameter.append('uri', String(uri));
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} articleId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticle: function (articleId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'articleId' is not null or undefined
            if (articleId === null || articleId === undefined) {
                throw new runtime_1.RequiredError('articleId', 'Required parameter articleId was null or undefined when calling getArticle.');
            }
            var localVarPath = "/knowledge-library/article/{articleId}"
                .replace('{articleId}', encodeURIComponent(String(articleId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} [accountId] <p>If a specific account is known, provide the ID, otherwise the best account will be automatically chosen.</p>
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeLibrary: function (accountId, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/knowledge-library";
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            if (accountId !== undefined) {
                localVarQueryParameter.append('accountId', String(accountId));
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} topicId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopic: function (topicId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'topicId' is not null or undefined
            if (topicId === null || topicId === undefined) {
                throw new runtime_1.RequiredError('topicId', 'Required parameter topicId was null or undefined when calling getTopic.');
            }
            var localVarPath = "/knowledge-library/topic/{topicId}"
                .replace('{topicId}', encodeURIComponent(String(topicId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
    };
};
exports.KnowledgeLibraryApiFetchParamCreator = KnowledgeLibraryApiFetchParamCreator;
/**
 * KnowledgeLibraryApi - functional programming interface
 * @export
 */
var KnowledgeLibraryApiFp = function (configuration) {
    return {
        /**
         * @param {string} uri
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        findKnowledgeLibraryObject: function (uri, options) {
            var localVarFetchArgs = (0, exports.KnowledgeLibraryApiFetchParamCreator)(configuration).findKnowledgeLibraryObject(uri, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 404) {
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} articleId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticle: function (articleId, options) {
            var localVarFetchArgs = (0, exports.KnowledgeLibraryApiFetchParamCreator)(configuration).getArticle(articleId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} [accountId] <p>If a specific account is known, provide the ID, otherwise the best account will be automatically chosen.</p>
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeLibrary: function (accountId, options) {
            var localVarFetchArgs = (0, exports.KnowledgeLibraryApiFetchParamCreator)(configuration).getKnowledgeLibrary(accountId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} topicId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopic: function (topicId, options) {
            var localVarFetchArgs = (0, exports.KnowledgeLibraryApiFetchParamCreator)(configuration).getTopic(topicId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
    };
};
exports.KnowledgeLibraryApiFp = KnowledgeLibraryApiFp;
/**
 * KnowledgeLibraryApi - factory interface
 * @export
 */
var KnowledgeLibraryApiFactory = function (configuration, basePath, fetch) {
    return new KnowledgeLibraryApi(configuration, basePath, fetch);
};
exports.KnowledgeLibraryApiFactory = KnowledgeLibraryApiFactory;
/**
 * KnowledgeLibraryApi - object-oriented interface
 * @export
 * @class KnowledgeLibraryApi
 * @extends {BaseAPI}
 */
var KnowledgeLibraryApi = /** @class */ (function (_super) {
    __extends(KnowledgeLibraryApi, _super);
    function KnowledgeLibraryApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {string} uri
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    KnowledgeLibraryApi.prototype.findKnowledgeLibraryObject = function (uri, options) {
        return (0, exports.KnowledgeLibraryApiFp)(this.configuration).findKnowledgeLibraryObject(uri, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} articleId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    KnowledgeLibraryApi.prototype.getArticle = function (articleId, options) {
        return (0, exports.KnowledgeLibraryApiFp)(this.configuration).getArticle(articleId, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} [accountId] <p>If a specific account is known, provide the ID, otherwise the best account will be automatically chosen.</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    KnowledgeLibraryApi.prototype.getKnowledgeLibrary = function (accountId, options) {
        return (0, exports.KnowledgeLibraryApiFp)(this.configuration).getKnowledgeLibrary(accountId, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} topicId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    KnowledgeLibraryApi.prototype.getTopic = function (topicId, options) {
        return (0, exports.KnowledgeLibraryApiFp)(this.configuration).getTopic(topicId, options)(this.fetch, this.basePath);
    };
    return KnowledgeLibraryApi;
}(runtime_1.BaseAPI));
exports.KnowledgeLibraryApi = KnowledgeLibraryApi;
/**
 * ParticipationApi - fetch parameter creator
 * @export
 */
var ParticipationApiFetchParamCreator = function (configuration) {
    return {
        /**
         * <p>This is used when an email is sent to the user in order for them to confirm their email address and claim the participation.
         * This endpoint does not require authentication, as all of the credentials are embedded in the token.</p>
         * @summary Register a participation to a Person using a token
         * @param {Api.ClaimParticipationRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimParticipation: function (request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling claimParticipation.');
            }
            var localVarPath = "/participation/claim";
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            localVarHeaderParameter.set('Content-Type', 'application/json');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * <p>Find the available participations</p>
         * @param {string} [token] <p>The specific participation token to use, if one was supplied. This will disambiguate if the person has multiple participations.</p>
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        findParticipationInfo: function (token, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/participations/find";
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            if (token !== undefined) {
                localVarQueryParameter.append('token', String(token));
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} participationId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipationReport: function (participationId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'participationId' is not null or undefined
            if (participationId === null || participationId === undefined) {
                throw new runtime_1.RequiredError('participationId', 'Required parameter participationId was null or undefined when calling getParticipationReport.');
            }
            var localVarPath = "/participation/{participationId}/report"
                .replace('{participationId}', encodeURIComponent(String(participationId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} participationId <p>Participation id</p>
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipationSurvey: function (participationId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'participationId' is not null or undefined
            if (participationId === null || participationId === undefined) {
                throw new runtime_1.RequiredError('participationId', 'Required parameter participationId was null or undefined when calling getParticipationSurvey.');
            }
            var localVarPath = "/participations/survey/{participationId}"
                .replace('{participationId}', encodeURIComponent(String(participationId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} participationId
         * @param {Api.AnswerRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAnswer: function (participationId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'participationId' is not null or undefined
            if (participationId === null || participationId === undefined) {
                throw new runtime_1.RequiredError('participationId', 'Required parameter participationId was null or undefined when calling postAnswer.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling postAnswer.');
            }
            var localVarPath = "/participation/{participationId}/answer"
                .replace('{participationId}', encodeURIComponent(String(participationId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} participationId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        postComplete: function (participationId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'participationId' is not null or undefined
            if (participationId === null || participationId === undefined) {
                throw new runtime_1.RequiredError('participationId', 'Required parameter participationId was null or undefined when calling postComplete.');
            }
            var localVarPath = "/participation/{participationId}/complete"
                .replace('{participationId}', encodeURIComponent(String(participationId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * <p>Register a participation to a Person</p>
         * @param {string} participationId
         * @param {Api.RegisterParticipationRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerParticipation: function (participationId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'participationId' is not null or undefined
            if (participationId === null || participationId === undefined) {
                throw new runtime_1.RequiredError('participationId', 'Required parameter participationId was null or undefined when calling registerParticipation.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling registerParticipation.');
            }
            var localVarPath = "/participation/{participationId}/register"
                .replace('{participationId}', encodeURIComponent(String(participationId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Start a participation using a survey token
         * @param {string} surveyToken
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSurveyWithToken: function (surveyToken, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyToken' is not null or undefined
            if (surveyToken === null || surveyToken === undefined) {
                throw new runtime_1.RequiredError('surveyToken', 'Required parameter surveyToken was null or undefined when calling startSurveyWithToken.');
            }
            var localVarPath = "/participations/survey";
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            if (surveyToken !== undefined) {
                localVarQueryParameter.append('surveyToken', String(surveyToken));
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ParticipationApiFetchParamCreator = ParticipationApiFetchParamCreator;
/**
 * ParticipationApi - functional programming interface
 * @export
 */
var ParticipationApiFp = function (configuration) {
    return {
        /**
         * <p>This is used when an email is sent to the user in order for them to confirm their email address and claim the participation.
         * This endpoint does not require authentication, as all of the credentials are embedded in the token.</p>
         * @summary Register a participation to a Person using a token
         * @param {Api.ClaimParticipationRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimParticipation: function (request, options) {
            var localVarFetchArgs = (0, exports.ParticipationApiFetchParamCreator)(configuration).claimParticipation(request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 204) {
                        return response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * <p>Find the available participations</p>
         * @param {string} [token] <p>The specific participation token to use, if one was supplied. This will disambiguate if the person has multiple participations.</p>
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        findParticipationInfo: function (token, options) {
            var localVarFetchArgs = (0, exports.ParticipationApiFetchParamCreator)(configuration).findParticipationInfo(token, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} participationId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipationReport: function (participationId, options) {
            var localVarFetchArgs = (0, exports.ParticipationApiFetchParamCreator)(configuration).getParticipationReport(participationId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} participationId <p>Participation id</p>
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipationSurvey: function (participationId, options) {
            var localVarFetchArgs = (0, exports.ParticipationApiFetchParamCreator)(configuration).getParticipationSurvey(participationId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} participationId
         * @param {Api.AnswerRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAnswer: function (participationId, request, options) {
            var localVarFetchArgs = (0, exports.ParticipationApiFetchParamCreator)(configuration).postAnswer(participationId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 204) {
                        return response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} participationId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        postComplete: function (participationId, options) {
            var localVarFetchArgs = (0, exports.ParticipationApiFetchParamCreator)(configuration).postComplete(participationId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 204) {
                        return response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * <p>Register a participation to a Person</p>
         * @param {string} participationId
         * @param {Api.RegisterParticipationRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerParticipation: function (participationId, request, options) {
            var localVarFetchArgs = (0, exports.ParticipationApiFetchParamCreator)(configuration).registerParticipation(participationId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Start a participation using a survey token
         * @param {string} surveyToken
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSurveyWithToken: function (surveyToken, options) {
            var localVarFetchArgs = (0, exports.ParticipationApiFetchParamCreator)(configuration).startSurveyWithToken(surveyToken, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
    };
};
exports.ParticipationApiFp = ParticipationApiFp;
/**
 * ParticipationApi - factory interface
 * @export
 */
var ParticipationApiFactory = function (configuration, basePath, fetch) {
    return new ParticipationApi(configuration, basePath, fetch);
};
exports.ParticipationApiFactory = ParticipationApiFactory;
/**
 * ParticipationApi - object-oriented interface
 * @export
 * @class ParticipationApi
 * @extends {BaseAPI}
 */
var ParticipationApi = /** @class */ (function (_super) {
    __extends(ParticipationApi, _super);
    function ParticipationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * <p>This is used when an email is sent to the user in order for them to confirm their email address and claim the participation.
     * This endpoint does not require authentication, as all of the credentials are embedded in the token.</p>
     * @summary Register a participation to a Person using a token
     * @param {Api.ClaimParticipationRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    ParticipationApi.prototype.claimParticipation = function (request, options) {
        return (0, exports.ParticipationApiFp)(this.configuration).claimParticipation(request, options)(this.fetch, this.basePath);
    };
    /**
     * <p>Find the available participations</p>
     * @param {string} [token] <p>The specific participation token to use, if one was supplied. This will disambiguate if the person has multiple participations.</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    ParticipationApi.prototype.findParticipationInfo = function (token, options) {
        return (0, exports.ParticipationApiFp)(this.configuration).findParticipationInfo(token, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} participationId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    ParticipationApi.prototype.getParticipationReport = function (participationId, options) {
        return (0, exports.ParticipationApiFp)(this.configuration).getParticipationReport(participationId, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} participationId <p>Participation id</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    ParticipationApi.prototype.getParticipationSurvey = function (participationId, options) {
        return (0, exports.ParticipationApiFp)(this.configuration).getParticipationSurvey(participationId, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} participationId
     * @param {Api.AnswerRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    ParticipationApi.prototype.postAnswer = function (participationId, request, options) {
        return (0, exports.ParticipationApiFp)(this.configuration).postAnswer(participationId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} participationId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    ParticipationApi.prototype.postComplete = function (participationId, options) {
        return (0, exports.ParticipationApiFp)(this.configuration).postComplete(participationId, options)(this.fetch, this.basePath);
    };
    /**
     * <p>Register a participation to a Person</p>
     * @param {string} participationId
     * @param {Api.RegisterParticipationRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    ParticipationApi.prototype.registerParticipation = function (participationId, request, options) {
        return (0, exports.ParticipationApiFp)(this.configuration).registerParticipation(participationId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Start a participation using a survey token
     * @param {string} surveyToken
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    ParticipationApi.prototype.startSurveyWithToken = function (surveyToken, options) {
        return (0, exports.ParticipationApiFp)(this.configuration).startSurveyWithToken(surveyToken, options)(this.fetch, this.basePath);
    };
    return ParticipationApi;
}(runtime_1.BaseAPI));
exports.ParticipationApi = ParticipationApi;
/**
 * PersonApi - fetch parameter creator
 * @export
 */
var PersonApiFetchParamCreator = function (configuration) {
    return {
        /**
         * @summary Confirm the TOTP setup and apply it to the current person.
         * @param {Api.ConfirmTotpRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmTotp: function (request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling confirmTotp.');
            }
            var localVarPath = "/person/totp/confirm";
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * <p>This is how to get details of who you&#39;ve authenticated as, and the accounts that you can access.</p>
         * @summary Get details of the currently authenticated user.
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyDetails: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/person/me";
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Start the process of setting up TOTP on an account.
         * @param {Api.StartTotpRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTotp: function (request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling startTotp.');
            }
            var localVarPath = "/person/totp";
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Update the details of the currently authenticated user
         * @param {Api.UpdateMyDetailsRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyDetails: function (request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling updateMyDetails.');
            }
            var localVarPath = "/person/me";
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PersonApiFetchParamCreator = PersonApiFetchParamCreator;
/**
 * PersonApi - functional programming interface
 * @export
 */
var PersonApiFp = function (configuration) {
    return {
        /**
         * @summary Confirm the TOTP setup and apply it to the current person.
         * @param {Api.ConfirmTotpRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmTotp: function (request, options) {
            var localVarFetchArgs = (0, exports.PersonApiFetchParamCreator)(configuration).confirmTotp(request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 201) {
                        return response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * <p>This is how to get details of who you&#39;ve authenticated as, and the accounts that you can access.</p>
         * @summary Get details of the currently authenticated user.
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyDetails: function (options) {
            var localVarFetchArgs = (0, exports.PersonApiFetchParamCreator)(configuration).getMyDetails(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Start the process of setting up TOTP on an account.
         * @param {Api.StartTotpRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTotp: function (request, options) {
            var localVarFetchArgs = (0, exports.PersonApiFetchParamCreator)(configuration).startTotp(request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Update the details of the currently authenticated user
         * @param {Api.UpdateMyDetailsRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyDetails: function (request, options) {
            var localVarFetchArgs = (0, exports.PersonApiFetchParamCreator)(configuration).updateMyDetails(request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
    };
};
exports.PersonApiFp = PersonApiFp;
/**
 * PersonApi - factory interface
 * @export
 */
var PersonApiFactory = function (configuration, basePath, fetch) {
    return new PersonApi(configuration, basePath, fetch);
};
exports.PersonApiFactory = PersonApiFactory;
/**
 * PersonApi - object-oriented interface
 * @export
 * @class PersonApi
 * @extends {BaseAPI}
 */
var PersonApi = /** @class */ (function (_super) {
    __extends(PersonApi, _super);
    function PersonApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @summary Confirm the TOTP setup and apply it to the current person.
     * @param {Api.ConfirmTotpRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    PersonApi.prototype.confirmTotp = function (request, options) {
        return (0, exports.PersonApiFp)(this.configuration).confirmTotp(request, options)(this.fetch, this.basePath);
    };
    /**
     * <p>This is how to get details of who you&#39;ve authenticated as, and the accounts that you can access.</p>
     * @summary Get details of the currently authenticated user.
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    PersonApi.prototype.getMyDetails = function (options) {
        return (0, exports.PersonApiFp)(this.configuration).getMyDetails(options)(this.fetch, this.basePath);
    };
    /**
     * @summary Start the process of setting up TOTP on an account.
     * @param {Api.StartTotpRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    PersonApi.prototype.startTotp = function (request, options) {
        return (0, exports.PersonApiFp)(this.configuration).startTotp(request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Update the details of the currently authenticated user
     * @param {Api.UpdateMyDetailsRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    PersonApi.prototype.updateMyDetails = function (request, options) {
        return (0, exports.PersonApiFp)(this.configuration).updateMyDetails(request, options)(this.fetch, this.basePath);
    };
    return PersonApi;
}(runtime_1.BaseAPI));
exports.PersonApi = PersonApi;
/**
 * SurveyApi - fetch parameter creator
 * @export
 */
var SurveyApiFetchParamCreator = function (configuration) {
    return {
        /**
         * @summary Add participants groups to the survey.
         * @param {string} surveyId
         * @param {Api.AddGroupsRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroups: function (surveyId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling addGroups.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling addGroups.');
            }
            var localVarPath = "/survey/{surveyId}/groups"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} surveyId
         * @param {Api.AddParticipantsRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        addParticipants: function (surveyId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling addParticipants.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling addParticipants.');
            }
            var localVarPath = "/survey/{surveyId}/participations"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Manually close the survey.
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeSurvey: function (surveyId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling closeSurvey.');
            }
            var localVarPath = "/survey/{surveyId}/close"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Add a custom question
         * @param {string} surveyId
         * @param {string} sectionId
         * @param {Api.Questions} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomQuestion: function (surveyId, sectionId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling createCustomQuestion.');
            }
            // verify required parameter 'sectionId' is not null or undefined
            if (sectionId === null || sectionId === undefined) {
                throw new runtime_1.RequiredError('sectionId', 'Required parameter sectionId was null or undefined when calling createCustomQuestion.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling createCustomQuestion.');
            }
            var localVarPath = "/survey/{surveyId}/section/{sectionId}/questions"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)))
                .replace('{sectionId}', encodeURIComponent(String(sectionId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Creates a preview participation
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreview: function (surveyId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling createPreview.');
            }
            var localVarPath = "/survey/{surveyId}/preview"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurvey: function (surveyId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling deleteSurvey.');
            }
            var localVarPath = "/survey/{surveyId}"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Download a report as a PDF
         * @param {string} surveyId
         * @param {string} token <p>The download token</p>
         * @param {string} frontend <p>Base URL for the current frontend</p>
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReport: function (surveyId, token, frontend, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling downloadReport.');
            }
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new runtime_1.RequiredError('token', 'Required parameter token was null or undefined when calling downloadReport.');
            }
            // verify required parameter 'frontend' is not null or undefined
            if (frontend === null || frontend === undefined) {
                throw new runtime_1.RequiredError('frontend', 'Required parameter frontend was null or undefined when calling downloadReport.');
            }
            var localVarPath = "/survey/{surveyId}/report/download"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            if (token !== undefined) {
                localVarQueryParameter.append('token', String(token));
            }
            if (frontend !== undefined) {
                localVarQueryParameter.append('frontend', String(frontend));
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} surveyId
         * @param {string} sectionId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomSection: function (surveyId, sectionId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling getCustomSection.');
            }
            // verify required parameter 'sectionId' is not null or undefined
            if (sectionId === null || sectionId === undefined) {
                throw new runtime_1.RequiredError('sectionId', 'Required parameter sectionId was null or undefined when calling getCustomSection.');
            }
            var localVarPath = "/survey/{surveyId}/section/{sectionId}"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)))
                .replace('{sectionId}', encodeURIComponent(String(sectionId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Get the filters available for the survey.
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilters: function (surveyId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling getFilters.');
            }
            var localVarPath = "/survey/{surveyId}/filters"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary The list of participant groups that have been added to the survey.
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: function (surveyId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling getGroups.');
            }
            var localVarPath = "/survey/{surveyId}/groups"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} surveyId
         * @param {string} [cursor]
         * @param {Api.SortParticipants} [sort]
         * @param {Api.FilterSurveyParticipants[]} [filter]
         * @param {string[]} [groups]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipations: function (surveyId, cursor, sort, filter, groups, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling getParticipations.');
            }
            var localVarPath = "/survey/{surveyId}/participations"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            if (cursor !== undefined) {
                localVarQueryParameter.append('cursor', String(cursor));
            }
            if (sort !== undefined) {
                localVarQueryParameter.append('sort', String(sort));
            }
            if (filter !== undefined) {
                /* array form exploded */
                for (var _i = 0, filter_2 = filter; _i < filter_2.length; _i++) {
                    var localVarArrayElement = filter_2[_i];
                    if (localVarArrayElement !== undefined) {
                        localVarQueryParameter.append('filter', localVarArrayElement !== null ? String(localVarArrayElement) : '');
                    }
                }
            }
            if (groups !== undefined) {
                /* array form exploded */
                for (var _a = 0, groups_1 = groups; _a < groups_1.length; _a++) {
                    var localVarArrayElement = groups_1[_a];
                    if (localVarArrayElement !== undefined) {
                        localVarQueryParameter.append('groups', localVarArrayElement !== null ? String(localVarArrayElement) : '');
                    }
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Get the report for the survey.
         * @param {string} surveyId
         * @param {Api.ReportOptions} [request]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport: function (surveyId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling getReport.');
            }
            var localVarPath = "/survey/{surveyId}/report"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Get survey details
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurvey: function (surveyId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling getSurvey.');
            }
            var localVarPath = "/survey/{surveyId}"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Manually open the survey.
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        openSurvey: function (surveyId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling openSurvey.');
            }
            var localVarPath = "/survey/{surveyId}/open"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Update a survey
         * @param {string} surveyId
         * @param {Api.SurveyDetailsUpdate} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSurvey: function (surveyId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling patchSurvey.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling patchSurvey.');
            }
            var localVarPath = "/survey/{surveyId}"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Update a survey report
         * @param {string} surveyId
         * @param {Api.SurveyReportUpdate} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSurveyReport: function (surveyId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling patchSurveyReport.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling patchSurveyReport.');
            }
            var localVarPath = "/survey/{surveyId}/report"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * <p>sends email with a reminder to a person associated with participation</p>
         * @summary endpoint for sending reminders to survey participants by participationId
         * @param {string} surveyId
         * @param {Api.PostRemindersRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReminders: function (surveyId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling postReminders.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling postReminders.');
            }
            var localVarPath = "/survey/{surveyId}/participations/reminders"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Remove participant groups from the survey.
         * @param {string} surveyId
         * @param {Api.RemoveGroupsRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGroups: function (surveyId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling removeGroups.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling removeGroups.');
            }
            var localVarPath = "/survey/{surveyId}/groups"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} surveyId
         * @param {Api.RemoveParticipationsRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeParticipations: function (surveyId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling removeParticipations.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling removeParticipations.');
            }
            var localVarPath = "/survey/{surveyId}/participations"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} surveyId
         * @param {string} sectionId
         * @param {string} questionId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeQuestion: function (surveyId, sectionId, questionId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling removeQuestion.');
            }
            // verify required parameter 'sectionId' is not null or undefined
            if (sectionId === null || sectionId === undefined) {
                throw new runtime_1.RequiredError('sectionId', 'Required parameter sectionId was null or undefined when calling removeQuestion.');
            }
            // verify required parameter 'questionId' is not null or undefined
            if (questionId === null || questionId === undefined) {
                throw new runtime_1.RequiredError('questionId', 'Required parameter questionId was null or undefined when calling removeQuestion.');
            }
            var localVarPath = "/survey/{surveyId}/section/{sectionId}/question/{questionId}"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)))
                .replace('{sectionId}', encodeURIComponent(String(sectionId)))
                .replace('{questionId}', encodeURIComponent(String(questionId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Request a token to download a report
         * @param {string} surveyId
         * @param {Api.ReportOptions} [request]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestReportDownload: function (surveyId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling requestReportDownload.');
            }
            var localVarPath = "/survey/{surveyId}/report/request-download"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Resend thanks emails to participants
         * @param {string} surveyId
         * @param {Api.ResendThanksRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendThanks: function (surveyId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling resendThanks.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling resendThanks.');
            }
            var localVarPath = "/survey/{surveyId}/participations/thanks"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} surveyId
         * @param {string} sectionId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetCustomSection: function (surveyId, sectionId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling resetCustomSection.');
            }
            // verify required parameter 'sectionId' is not null or undefined
            if (sectionId === null || sectionId === undefined) {
                throw new runtime_1.RequiredError('sectionId', 'Required parameter sectionId was null or undefined when calling resetCustomSection.');
            }
            var localVarPath = "/survey/{surveyId}/section/{sectionId}"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)))
                .replace('{sectionId}', encodeURIComponent(String(sectionId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {string} surveyId
         * @param {string} query
         * @param {string} [cursor]
         * @param {Api.SortParticipants} [sort]
         * @param {Api.FilterSurveyParticipants[]} [filter]
         * @param {string[]} [groups]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchParticipations: function (surveyId, query, cursor, sort, filter, groups, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling searchParticipations.');
            }
            // verify required parameter 'query' is not null or undefined
            if (query === null || query === undefined) {
                throw new runtime_1.RequiredError('query', 'Required parameter query was null or undefined when calling searchParticipations.');
            }
            var localVarPath = "/survey/{surveyId}/participants/search"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            if (query !== undefined) {
                localVarQueryParameter.append('query', String(query));
            }
            if (cursor !== undefined) {
                localVarQueryParameter.append('cursor', String(cursor));
            }
            if (sort !== undefined) {
                localVarQueryParameter.append('sort', String(sort));
            }
            if (filter !== undefined) {
                /* array form exploded */
                for (var _i = 0, filter_3 = filter; _i < filter_3.length; _i++) {
                    var localVarArrayElement = filter_3[_i];
                    if (localVarArrayElement !== undefined) {
                        localVarQueryParameter.append('filter', localVarArrayElement !== null ? String(localVarArrayElement) : '');
                    }
                }
            }
            if (groups !== undefined) {
                /* array form exploded */
                for (var _a = 0, groups_2 = groups; _a < groups_2.length; _a++) {
                    var localVarArrayElement = groups_2[_a];
                    if (localVarArrayElement !== undefined) {
                        localVarQueryParameter.append('groups', localVarArrayElement !== null ? String(localVarArrayElement) : '');
                    }
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Send reminders to participants
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReminders: function (surveyId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling sendReminders.');
            }
            var localVarPath = "/survey/{surveyId}/sendReminders"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarRequestOptions.headers = localVarHeaderParameter;
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary sets custom questions in the order specified.
         * @param {string} surveyId
         * @param {string} sectionId
         * @param {string[]} [request]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCustomQuestions: function (surveyId, sectionId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling setCustomQuestions.');
            }
            // verify required parameter 'sectionId' is not null or undefined
            if (sectionId === null || sectionId === undefined) {
                throw new runtime_1.RequiredError('sectionId', 'Required parameter sectionId was null or undefined when calling setCustomQuestions.');
            }
            var localVarPath = "/survey/{surveyId}/section/{sectionId}/questions"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)))
                .replace('{sectionId}', encodeURIComponent(String(sectionId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Update a custom question
         * @param {string} surveyId
         * @param {string} sectionId
         * @param {string} questionId
         * @param {Api.Questions} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomQuestion: function (surveyId, sectionId, questionId, request, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new runtime_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling updateCustomQuestion.');
            }
            // verify required parameter 'sectionId' is not null or undefined
            if (sectionId === null || sectionId === undefined) {
                throw new runtime_1.RequiredError('sectionId', 'Required parameter sectionId was null or undefined when calling updateCustomQuestion.');
            }
            // verify required parameter 'questionId' is not null or undefined
            if (questionId === null || questionId === undefined) {
                throw new runtime_1.RequiredError('questionId', 'Required parameter questionId was null or undefined when calling updateCustomQuestion.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new runtime_1.RequiredError('request', 'Required parameter request was null or undefined when calling updateCustomQuestion.');
            }
            var localVarPath = "/survey/{surveyId}/section/{sectionId}/question/{questionId}"
                .replace('{surveyId}', encodeURIComponent(String(surveyId)))
                .replace('{sectionId}', encodeURIComponent(String(sectionId)))
                .replace('{questionId}', encodeURIComponent(String(questionId)));
            var localVarPathQueryStart = localVarPath.indexOf("?");
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = options.headers ? new Headers(options.headers) : new Headers();
            var localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
            if (localVarPathQueryStart !== -1) {
                localVarPath = localVarPath.substring(0, localVarPathQueryStart);
            }
            // authentication oAuthSample required
            // oauth or openIdConnect required
            if (configuration && configuration.authorization) {
                var localVarAuthorizationValue = typeof configuration.authorization === 'function'
                    ? configuration.authorization('oAuthSample', [])
                    : configuration.authorization;
                if (localVarAuthorizationValue !== null) {
                    localVarHeaderParameter.set("Authorization", "Bearer " + localVarAuthorizationValue);
                }
            }
            localVarHeaderParameter.set('Content-Type', 'application/json; charset=UTF-8');
            localVarRequestOptions.headers = localVarHeaderParameter;
            if (request !== undefined) {
                localVarRequestOptions.body = JSON.stringify(request || {});
            }
            var localVarQueryParameterString = localVarQueryParameter.toString();
            if (localVarQueryParameterString) {
                localVarPath += "?" + localVarQueryParameterString;
            }
            return {
                url: localVarPath,
                options: localVarRequestOptions,
            };
        },
    };
};
exports.SurveyApiFetchParamCreator = SurveyApiFetchParamCreator;
/**
 * SurveyApi - functional programming interface
 * @export
 */
var SurveyApiFp = function (configuration) {
    return {
        /**
         * @summary Add participants groups to the survey.
         * @param {string} surveyId
         * @param {Api.AddGroupsRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroups: function (surveyId, request, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).addGroups(surveyId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 201) {
                        return response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} surveyId
         * @param {Api.AddParticipantsRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        addParticipants: function (surveyId, request, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).addParticipants(surveyId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Manually close the survey.
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeSurvey: function (surveyId, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).closeSurvey(surveyId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Add a custom question
         * @param {string} surveyId
         * @param {string} sectionId
         * @param {Api.Questions} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomQuestion: function (surveyId, sectionId, request, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).createCustomQuestion(surveyId, sectionId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Creates a preview participation
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreview: function (surveyId, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).createPreview(surveyId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurvey: function (surveyId, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).deleteSurvey(surveyId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 204) {
                        return response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Download a report as a PDF
         * @param {string} surveyId
         * @param {string} token <p>The download token</p>
         * @param {string} frontend <p>Base URL for the current frontend</p>
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReport: function (surveyId, token, frontend, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).downloadReport(surveyId, token, frontend, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        return response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} surveyId
         * @param {string} sectionId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomSection: function (surveyId, sectionId, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).getCustomSection(surveyId, sectionId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Get the filters available for the survey.
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilters: function (surveyId, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).getFilters(surveyId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary The list of participant groups that have been added to the survey.
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: function (surveyId, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).getGroups(surveyId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} surveyId
         * @param {string} [cursor]
         * @param {Api.SortParticipants} [sort]
         * @param {Api.FilterSurveyParticipants[]} [filter]
         * @param {string[]} [groups]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipations: function (surveyId, cursor, sort, filter, groups, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).getParticipations(surveyId, cursor, sort, filter, groups, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Get the report for the survey.
         * @param {string} surveyId
         * @param {Api.ReportOptions} [request]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport: function (surveyId, request, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).getReport(surveyId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Get survey details
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurvey: function (surveyId, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).getSurvey(surveyId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Manually open the survey.
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        openSurvey: function (surveyId, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).openSurvey(surveyId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Update a survey
         * @param {string} surveyId
         * @param {Api.SurveyDetailsUpdate} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSurvey: function (surveyId, request, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).patchSurvey(surveyId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Update a survey report
         * @param {string} surveyId
         * @param {Api.SurveyReportUpdate} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSurveyReport: function (surveyId, request, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).patchSurveyReport(surveyId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * <p>sends email with a reminder to a person associated with participation</p>
         * @summary endpoint for sending reminders to survey participants by participationId
         * @param {string} surveyId
         * @param {Api.PostRemindersRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReminders: function (surveyId, request, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).postReminders(surveyId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Remove participant groups from the survey.
         * @param {string} surveyId
         * @param {Api.RemoveGroupsRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGroups: function (surveyId, request, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).removeGroups(surveyId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 204) {
                        return response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} surveyId
         * @param {Api.RemoveParticipationsRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeParticipations: function (surveyId, request, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).removeParticipations(surveyId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 204) {
                        return response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} surveyId
         * @param {string} sectionId
         * @param {string} questionId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeQuestion: function (surveyId, sectionId, questionId, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).removeQuestion(surveyId, sectionId, questionId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 204) {
                        return response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Request a token to download a report
         * @param {string} surveyId
         * @param {Api.ReportOptions} [request]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestReportDownload: function (surveyId, request, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).requestReportDownload(surveyId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Resend thanks emails to participants
         * @param {string} surveyId
         * @param {Api.ResendThanksRequest} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendThanks: function (surveyId, request, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).resendThanks(surveyId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} surveyId
         * @param {string} sectionId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetCustomSection: function (surveyId, sectionId, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).resetCustomSection(surveyId, sectionId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @param {string} surveyId
         * @param {string} query
         * @param {string} [cursor]
         * @param {Api.SortParticipants} [sort]
         * @param {Api.FilterSurveyParticipants[]} [filter]
         * @param {string[]} [groups]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchParticipations: function (surveyId, query, cursor, sort, filter, groups, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).searchParticipations(surveyId, query, cursor, sort, filter, groups, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Send reminders to participants
         * @param {string} surveyId
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReminders: function (surveyId, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).sendReminders(surveyId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary sets custom questions in the order specified.
         * @param {string} surveyId
         * @param {string} sectionId
         * @param {string[]} [request]
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCustomQuestions: function (surveyId, sectionId, request, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).setCustomQuestions(surveyId, sectionId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
        /**
         * @summary Update a custom question
         * @param {string} surveyId
         * @param {string} sectionId
         * @param {string} questionId
         * @param {Api.Questions} request
         * @param {RequestInit} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomQuestion: function (surveyId, sectionId, questionId, request, options) {
            var localVarFetchArgs = (0, exports.SurveyApiFetchParamCreator)(configuration).updateCustomQuestion(surveyId, sectionId, questionId, request, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = runtime_1.defaultFetch; }
                if (basePath === void 0) { basePath = runtime_1.BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    var contentType = response.headers.get('Content-Type');
                    var mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
                    if (response.status === 200) {
                        if (mimeType === 'application/json') {
                            return response.json();
                        }
                        throw response;
                    }
                    if (response.status === 400) {
                        if (mimeType === 'application/json') {
                            throw response;
                        }
                        throw response;
                    }
                    throw response;
                });
            };
        },
    };
};
exports.SurveyApiFp = SurveyApiFp;
/**
 * SurveyApi - factory interface
 * @export
 */
var SurveyApiFactory = function (configuration, basePath, fetch) {
    return new SurveyApi(configuration, basePath, fetch);
};
exports.SurveyApiFactory = SurveyApiFactory;
/**
 * SurveyApi - object-oriented interface
 * @export
 * @class SurveyApi
 * @extends {BaseAPI}
 */
var SurveyApi = /** @class */ (function (_super) {
    __extends(SurveyApi, _super);
    function SurveyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @summary Add participants groups to the survey.
     * @param {string} surveyId
     * @param {Api.AddGroupsRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.addGroups = function (surveyId, request, options) {
        return (0, exports.SurveyApiFp)(this.configuration).addGroups(surveyId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} surveyId
     * @param {Api.AddParticipantsRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.addParticipants = function (surveyId, request, options) {
        return (0, exports.SurveyApiFp)(this.configuration).addParticipants(surveyId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Manually close the survey.
     * @param {string} surveyId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.closeSurvey = function (surveyId, options) {
        return (0, exports.SurveyApiFp)(this.configuration).closeSurvey(surveyId, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Add a custom question
     * @param {string} surveyId
     * @param {string} sectionId
     * @param {Api.Questions} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.createCustomQuestion = function (surveyId, sectionId, request, options) {
        return (0, exports.SurveyApiFp)(this.configuration).createCustomQuestion(surveyId, sectionId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Creates a preview participation
     * @param {string} surveyId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.createPreview = function (surveyId, options) {
        return (0, exports.SurveyApiFp)(this.configuration).createPreview(surveyId, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} surveyId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.deleteSurvey = function (surveyId, options) {
        return (0, exports.SurveyApiFp)(this.configuration).deleteSurvey(surveyId, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Download a report as a PDF
     * @param {string} surveyId
     * @param {string} token <p>The download token</p>
     * @param {string} frontend <p>Base URL for the current frontend</p>
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.downloadReport = function (surveyId, token, frontend, options) {
        return (0, exports.SurveyApiFp)(this.configuration).downloadReport(surveyId, token, frontend, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} surveyId
     * @param {string} sectionId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.getCustomSection = function (surveyId, sectionId, options) {
        return (0, exports.SurveyApiFp)(this.configuration).getCustomSection(surveyId, sectionId, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Get the filters available for the survey.
     * @param {string} surveyId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.getFilters = function (surveyId, options) {
        return (0, exports.SurveyApiFp)(this.configuration).getFilters(surveyId, options)(this.fetch, this.basePath);
    };
    /**
     * @summary The list of participant groups that have been added to the survey.
     * @param {string} surveyId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.getGroups = function (surveyId, options) {
        return (0, exports.SurveyApiFp)(this.configuration).getGroups(surveyId, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} surveyId
     * @param {string} [cursor]
     * @param {Api.SortParticipants} [sort]
     * @param {Api.FilterSurveyParticipants[]} [filter]
     * @param {string[]} [groups]
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.getParticipations = function (surveyId, cursor, sort, filter, groups, options) {
        return (0, exports.SurveyApiFp)(this.configuration).getParticipations(surveyId, cursor, sort, filter, groups, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Get the report for the survey.
     * @param {string} surveyId
     * @param {Api.ReportOptions} [request]
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.getReport = function (surveyId, request, options) {
        return (0, exports.SurveyApiFp)(this.configuration).getReport(surveyId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Get survey details
     * @param {string} surveyId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.getSurvey = function (surveyId, options) {
        return (0, exports.SurveyApiFp)(this.configuration).getSurvey(surveyId, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Manually open the survey.
     * @param {string} surveyId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.openSurvey = function (surveyId, options) {
        return (0, exports.SurveyApiFp)(this.configuration).openSurvey(surveyId, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Update a survey
     * @param {string} surveyId
     * @param {Api.SurveyDetailsUpdate} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.patchSurvey = function (surveyId, request, options) {
        return (0, exports.SurveyApiFp)(this.configuration).patchSurvey(surveyId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Update a survey report
     * @param {string} surveyId
     * @param {Api.SurveyReportUpdate} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.patchSurveyReport = function (surveyId, request, options) {
        return (0, exports.SurveyApiFp)(this.configuration).patchSurveyReport(surveyId, request, options)(this.fetch, this.basePath);
    };
    /**
     * <p>sends email with a reminder to a person associated with participation</p>
     * @summary endpoint for sending reminders to survey participants by participationId
     * @param {string} surveyId
     * @param {Api.PostRemindersRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.postReminders = function (surveyId, request, options) {
        return (0, exports.SurveyApiFp)(this.configuration).postReminders(surveyId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Remove participant groups from the survey.
     * @param {string} surveyId
     * @param {Api.RemoveGroupsRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.removeGroups = function (surveyId, request, options) {
        return (0, exports.SurveyApiFp)(this.configuration).removeGroups(surveyId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} surveyId
     * @param {Api.RemoveParticipationsRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.removeParticipations = function (surveyId, request, options) {
        return (0, exports.SurveyApiFp)(this.configuration).removeParticipations(surveyId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} surveyId
     * @param {string} sectionId
     * @param {string} questionId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.removeQuestion = function (surveyId, sectionId, questionId, options) {
        return (0, exports.SurveyApiFp)(this.configuration).removeQuestion(surveyId, sectionId, questionId, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Request a token to download a report
     * @param {string} surveyId
     * @param {Api.ReportOptions} [request]
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.requestReportDownload = function (surveyId, request, options) {
        return (0, exports.SurveyApiFp)(this.configuration).requestReportDownload(surveyId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Resend thanks emails to participants
     * @param {string} surveyId
     * @param {Api.ResendThanksRequest} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.resendThanks = function (surveyId, request, options) {
        return (0, exports.SurveyApiFp)(this.configuration).resendThanks(surveyId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} surveyId
     * @param {string} sectionId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.resetCustomSection = function (surveyId, sectionId, options) {
        return (0, exports.SurveyApiFp)(this.configuration).resetCustomSection(surveyId, sectionId, options)(this.fetch, this.basePath);
    };
    /**
     * @param {string} surveyId
     * @param {string} query
     * @param {string} [cursor]
     * @param {Api.SortParticipants} [sort]
     * @param {Api.FilterSurveyParticipants[]} [filter]
     * @param {string[]} [groups]
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.searchParticipations = function (surveyId, query, cursor, sort, filter, groups, options) {
        return (0, exports.SurveyApiFp)(this.configuration).searchParticipations(surveyId, query, cursor, sort, filter, groups, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Send reminders to participants
     * @param {string} surveyId
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.sendReminders = function (surveyId, options) {
        return (0, exports.SurveyApiFp)(this.configuration).sendReminders(surveyId, options)(this.fetch, this.basePath);
    };
    /**
     * @summary sets custom questions in the order specified.
     * @param {string} surveyId
     * @param {string} sectionId
     * @param {string[]} [request]
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.setCustomQuestions = function (surveyId, sectionId, request, options) {
        return (0, exports.SurveyApiFp)(this.configuration).setCustomQuestions(surveyId, sectionId, request, options)(this.fetch, this.basePath);
    };
    /**
     * @summary Update a custom question
     * @param {string} surveyId
     * @param {string} sectionId
     * @param {string} questionId
     * @param {Api.Questions} request
     * @param {RequestInit} [options] Override http request option.
     * @throws {RequiredError}
     */
    SurveyApi.prototype.updateCustomQuestion = function (surveyId, sectionId, questionId, request, options) {
        return (0, exports.SurveyApiFp)(this.configuration).updateCustomQuestion(surveyId, sectionId, questionId, request, options)(this.fetch, this.basePath);
    };
    return SurveyApi;
}(runtime_1.BaseAPI));
exports.SurveyApi = SurveyApi;
/**
 * We sometimes represent dates as strings (in models) and as Dates (in parameters) so this
 * function converts them both to a string.
 */
function dateToString(value) {
    if (value instanceof Date) {
        return value.toISOString();
    }
    else if (typeof value === 'string') {
        return value;
    }
    else {
        return undefined;
    }
}
